var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultSubcat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342",
    transform: "translate(11623 1043)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300",
    "data-name": "Rectangle 300",
    width: 150,
    height: 150,
    transform: "translate(-11623 -1043)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-image",
    "data-name": "Icon material-image",
    d: "M44.326,39.9V8.925A4.438,4.438,0,0,0,39.9,4.5H8.925A4.438,4.438,0,0,0,4.5,8.925V39.9a4.438,4.438,0,0,0,4.425,4.425H39.9A4.438,4.438,0,0,0,44.326,39.9ZM16.669,27.732l5.531,6.66,7.744-9.979L39.9,37.688H8.925Z",
    transform: "translate(-11572.413 -992.413)",
    opacity: 0.361
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultSubcat);
export default __webpack_public_path__ + "static/media/default_subcat.fedfeac4bf27e2e2834f56addef92187.svg";
export { ForwardRef as ReactComponent };